module.exports = __webpack_public_path__ + "static/media/Informationicon02.eb9902d5.png";